<template>
  <div class="row">
    <div class="col-lg-12 col-xs-12" v-if="selectedManagers.length > 0">
      <table class="table table-hover">
        <thead>
          <tr>
            <td class="center">#</td>
            <td class="center">Nome</td>
            <td class="center">Email</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(manager, index) in selectedManagers"
            :key="manager.email"
            @click="manager.checked = !manager.checked"
            class="h-auto"
          >
            <td class="center">
              <input type="checkbox" v-model="manager.checked" />
              <div class="d-inline" @click="removeManager(index, manager.id)">
                <i class="fas fa-trash color-red ml-1 scale_1"></i>
              </div>
            </td>
            <td class="center">
              <span
                class="text-truncate d-inline-block"
                :style="truncate ? 'max-width: 100px' : ''"
                :title="manager.name"
                >{{ manager.name }}</span
              >
            </td>
            <td class="center">
              <span
                class="text-truncate d-inline-block"
                :style="truncate ? 'max-width: 200px' : ''"
                :title="manager.email"
                >{{ manager.email }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-12 col-xs-12 mb-2">
      <input
        type="text"
        placeholder="Nome"
        v-model="manager.name"
        @blur="addManager"
        :class="inputClasses"
      />
    </div>
    <div class="col-lg-12 col-xs-12">
      <input
        type="email"
        placeholder="Email"
        @blur="addManager"
        v-model="manager.email"
        :class="inputClasses"
         v-on:keydown.enter="addManager"
      />
    </div>
    <div class="col-lg-12 col-xs-12 mt-2">
      <button 
        v-if="is_limited"
       class="btn-save-comment bg-purple mb-1 w-100" 
       @click="addManager">
        ADICIONAR DESTINATÁRIO​
      </button>
      <button 
       v-else
       class="btn-save-comment bg-purple mb-1 w-100" 
       @click="addManager">
        Adicionar gestor(a)
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["inputClasses", "truncate", "is_limited","job_id"],
  mounted() {
    this.populateManagers()
    eventBus.$on("getManagers", _ => {
      let managers = this.selectedManagers.filter(manager => manager.checked)
      this.$emit("input", managers)
    })
  },
  data: (_) => ({
    selectedManagers: [],
    manager: {
      name: "",
      email: "",
    },
  }),
  methods: {
    populateManagers(){
      axios
        .get(`/recruiters/manegers/show`).then((response) => {
          this.selectedManagers = response.data.managers;
        });
    },
    addManager() {
      if((this.manager.name && this.manager.email) != ''){
        this.selectedManagers.push({
          name: this.manager.name,
          email: this.manager.email,
          enable_show: true,
          checked: true,
        });
        this.manager.name = this.manager.email = "";
      } 
    },
    removeManager(index,id) {
      let conf = confirm(
        "Tem certeza que deseja remover este gestor(a) da lista?"
      );
      if (!conf) {
        this.selectedManagers[index].checked = !this.selectedManagers[index]
          .checked;
        return;
      }
          this.selectedManagers.splice(index, 1);
      if (id != undefined){
        axios
          .post(`/recruiters/manegers/${id}`).then((response) => {
            this.populateManagers()
          });
      }
    },
  },
};
</script>